import React from "react";
import { useTranslation } from "react-i18next";
import WarningIcon from "../../resources/icons/warning-thin.svg";

const ERROR = [
  {
    code: "organisation_already_exists",
    heading: "homeAuthPages:organisation_exists",
  },
  { code: "domain_already_exists", heading: "homeAuthPages:domain_exists" },
  { code: "account_not_active", heading: "homeAuthPages:account_not_active" },
  {
    code: "request_under_review",
    heading: "homeAuthPages:request_under_review",
  },
  {
    code: "use_company's_email",
    heading: "homeAuthPages:company_email_required",
  },
  {
    code: "account_already_exists",
    heading: "homeAuthPages:account_already_exists",
  },
  {
    code: "organisation_not_found",
    heading: "homeAuthPages:organisation_not_found",
  },
  {
    code: "organisation_pending",
    heading: "homeAuthPages:organisation_pending",
  },
];

const ErrorSignUpInNotification = ({ message, error, closeModal }) => {
  const { t } = useTranslation();

  const matchedError = ERROR.find((err) => err.code === error);

  const errorHeading = matchedError
    ? t(matchedError.heading)
    : t("homeAuthPages:error");

  return (
    <div
      id="error-signup-modal-overlay"
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={closeModal}
    >
      <div
        id="error-signup-modal"
        className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={WarningIcon} alt="Warning Icon" className="w-16 mx-auto" />
        <h3 className="text-2xl font-semibold mt-2">{errorHeading}</h3>
        <p id="error-signup-modal-message-description" className="text-gray-700 mt-2">{message}</p>
        <button
          id="error-signup-modal-got-it-button"
          className="mt-4 bg-cfButton hover:bg-cfPrimaryDark text-white py-2 px-6 rounded-md"
          onClick={closeModal}
        >
          {t("homeAuthPages:got_it")}
        </button>
      </div>
    </div>
  );
};

export default ErrorSignUpInNotification;
